import { Injectable } from '@angular/core';
import { TableFiltersIndicator, TableSortIndicator } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType, SortDirection } from '@campaign-portal/namespace/common/rpc.params';

@Injectable({
	providedIn: 'root'
})
export class ManualDippingResultsTableFieldsService {
	readonly headers: EntityField[] = [
		{
			id: 0,
			name: 'manual_dipping.dnis',
			variable: 'number',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		},
		{
			id: 1,
			name: 'manual_dipping.task.mccmnc',
			variable: 'mccmnc',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		},
		{
			id: 2,
			name: 'manual_dipping.task.ported',
			variable: 'ported',
			required: false,
			type: InputComplexType.SELECT,
			filterType: FilterType.LIKE,
			data: ['Yes', 'No']
		},
		{
			id: 3,
			name: 'manual_dipping.source',
			variable: 'sourceName',
			required: false,
			type: InputComplexType.SELECT,
			filterType: FilterType.LIKE,
			data: []
		},
		{
			id: 4,
			name: 'manual_dipping.response_time',
			variable: 'responseTime',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		}
	];

}

export const MDRESULTS_TABLE_SORTING: TableSortIndicator = new Map()
	.set('number', { enabled: true, value: SortDirection.EMPTY });

export const MDRESULTS_TABLE_FILTERS: TableFiltersIndicator = new Map()
	.set('number', { enabled: true, value: undefined, filterType: FilterType.LIKE })
	.set('mccmnc', { enabled: true, value: undefined, filterType: FilterType.LIKE })
	.set('ported', { enabled: true, value: undefined, filterType: FilterType.LIKE })
	.set('sourceName', { enabled: true, value: undefined, filterType: FilterType.LIKE });
